import {UmpireMatchEvent} from '../umpire-match-event';
import {JsonApiResponse} from '@tisa-group/cdk/models';
import {UmpireIncident} from '../umpire-incident';
import {UmpireMatch} from '../umpire-match';

export interface MatchResultMatchTeamGoals {
  goals: UmpireIncident[];

  total: number;
}

export interface MatchResultScored {
  guestGoal: MatchResultMatchTeamGoals;

  hostGoal: MatchResultMatchTeamGoals;
}

export interface MatchResultScoredNull {
  guestGoal: MatchResultMatchTeamGoals | null;

  hostGoal: MatchResultMatchTeamGoals | null;
}

export interface MatchResultTemplateMatchData {
  incident: UmpireIncident;

  scored: MatchResultScored;
}

export interface MatchResultModel {
  scored: MatchResultScored;

  incidents: MatchResultTemplateMatchData[];
}

export interface MatchResultEvent {
  incidents: MatchResultModel;

  data: JsonApiResponse<UmpireMatchEvent>;
}
export interface MatchResultGoals {
  incidents: MatchResultModel;

  data: UmpireMatch;
}
